import {
    Divider, Typography, Button, Stack, Grid, Container, Paper, Tooltip,
    Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import ImageViewer from "../components/ImageViewer";
import { ExpandMore } from "@mui/icons-material";


export default function MeasurePage() {
    // Get id from URL
    const { id } = useParams();

    // Navigate function (for back button)
    const navigate = useNavigate()

    try { // IMPORTANT: try/catch block will navigate to homepage if the page of the specific measure does 
        // not exist or if there is some other error

        // GET data from the backend API
        var apidata = JSON.parse(sessionStorage.getItem('fullmeasures'))//FetchRequest('fullmeasures');


        // Function to filter the complete json file for the specific measure
        function getMeasureByID_API(data, ID) {
            return data.filter(
                function (data) { return data['measure_number'] === ID }
            )
        };



        // This if statement waits until the GET request is complete before continuing and returning the whole page.
        // Until the GET is complete, only null is returned
        if (apidata !== undefined) {
            var measureData = getMeasureByID_API(apidata, id)[0]

            //General information
            var title = (measureData['pub_title'] !== null) ? measureData['pub_title'].replaceAll('\\n', '. ') : measureData['pub_title'];
            var year = measureData['pub_year']
            var category = measureData['measure_category']
            var subcat = measureData['measure_subcategory']
            var measure_type = measureData['measure_type']

            // About
            var name = measureData['measure_name']
            var country = measureData['country']
            var nra = measureData['NRA']
            var duration = measureData['measure_duration']
            var method = measureData['measure_implementation_method']
            var details = measureData['measure_details']
            // .split(/[\n]+/)         
            // .map(makeList)

            var authors = measureData['author']
            // .split(/[\n]+/)
            // .map(makeList)

            // Effect
            var methodImpact = measureData['Method of Impact Assessment']
            var capacity_impact = measureData['capacity_impact']
            var safety_impact = measureData['safety_impact']
            var env_impact = measureData['environment_impact']
            var cost_impact = measureData['investment_cost']
            var effect_overall = measureData['overall_effectiveness']
            var capacity_comment = measureData['comments_capacity']
            var safety_comment = measureData['comments_safety']
            var env_comment = measureData['comments_environment']
            var cost_comment = measureData['comments_costs']
            var effect_comment = measureData['comments_effectiveness']
            var acceptance = measureData['acceptance']
            var challenges = measureData['challenges']

            // Publication
            var report_type = measureData['report_type']
            var project_link = measureData['link']
            var references = measureData['References']
            var otherInformation = measureData['Other_Information']

            // Function to check if the value of the content in the json was not null, else say 'not specified'.
            // Turns links into clickable links if hasLink=true
            // Turns paragraphs with a newline separator into paragraphs of text
            function hasContent(string, hasLink = false) {
                if (hasLink && string) {
                    var chopstring = string.toString().split(/[\n\s]+/)
                    var linkArr = []
                    var descArr = []
                    // Chop string into words, check if each word is a link or not 
                    for (const elem of chopstring) {
                        if (elem.startsWith('http')) {
                            linkArr.push(elem)
                        } else {
                            descArr.push(elem)
                        }
                    }

                    return (
                        <>
                            {/* Turn non-link words back into string */}
                            {<Typography paragraph>{descArr.join(' ')}</Typography>}

                            {/* Turn every link into a <p>-wrapped <a> element that opens in a new tab */}
                            {linkArr.map(elem => <p key={elem}><a href={elem} target="_blank" rel="noopener noreferrer" >{elem}</a> </p>)}

                        </>
                    )

                } else if (!hasLink && string) {
                    // Chop string into sentences based on newline chars
                    var chopstring = string.toString().split(/[\n]+/)
                    // Return a typography paragraph for each 'sentence'
                    return (
                        <>
                            {chopstring.map((elem) => <Typography paragraph key={elem}>{elem}</Typography>)}
                        </>
                    )

                } else {
                    return <Typography paragraph>Not specified</Typography>
                }
            };


            function EffectElement(content) {
                var verifiedContent = (content) ? content : 'Not specified' //Check if the content is not null

                // Arrays for words denoting positive effect, negative effect or amplifying words
                const posArr = ['positive', 'increase', 'very effective', 'low']
                const negArr = ['negative', 'decrease', 'not effective', 'high']
                const weakArr = ['effective']

                // Colors to use in 5 situations (from the theme)
                const colors = {
                    'positive': 'primary.main',
                    'weakpos': 'primary.weakpos',
                    'neutral': 'secondary.main',
                    'negative': 'primary.negative'
                }

                // Transform to lower case and check if the string contains one of the words. Makes boolean
                var lowerContent = verifiedContent.toLowerCase()
                var stringIncludesPos = posArr.some(word => lowerContent.includes(word))
                var stringIncludesNeg = negArr.some(word => lowerContent.includes(word))
                var stringIsWeak = weakArr.some(word => lowerContent.includes(word))

                // Default = neutral (grey/white)
                var elementColor = 'colors.neutral'

                // Bunch of if statements (can be more elegant?)
                if (stringIncludesPos) { elementColor = colors.positive }
                else if (stringIncludesNeg) { elementColor = colors.negative }
                else if (stringIsWeak) { elementColor = colors.weakpos }

                // Typography component with a background
                return <Typography paragraph sx={{
                    borderRadius: '50%',
                    display: 'inline-flex',
                    height: '30px',
                    padding: '4px',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    backgroundColor: elementColor,
                }}>
                    {verifiedContent}
                </Typography>
            }


            return (
                <Container disableGutters>
                    <Tooltip title='Back to overview'>
                        <Button
                            variant='contained'
                            onClick={() => navigate('/')}>
                            Back to overview
                        </Button>
                    </Tooltip>

                    <Paper
                        sx={{ padding: 2, marginTop: 2 }}>

                        <Accordion defaultExpanded className='Summary' sx={{ boxShadow: 0 }}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="Summary-panel_content"
                                id="Summary-panel"
                            >
                                <Typography variant='h5'>{title ? title : 'No title'}</Typography>
                            </AccordionSummary>
                            <Divider />

                            <AccordionDetails>
                                <Grid container>
                                    <Grid item md={5}>
                                        <Stack direction='row' spacing={4}>
                                            <Stack>
                                                <Typography paragraph>Country               </Typography>
                                                <Typography paragraph>Publication year      </Typography>
                                                <Typography paragraph>Responsible NRA       </Typography>
                                                <Typography paragraph>Category              </Typography>
                                                <Typography paragraph>Sub-category          </Typography>
                                                <Typography paragraph>Type of Measure       </Typography>
                                            </Stack>
                                            <Stack>
                                                {hasContent(country)}
                                                {hasContent(year)}
                                                {hasContent(nra)}
                                                {hasContent(category)}
                                                {hasContent(subcat)}
                                                {hasContent(measure_type)}
                                            </Stack>
                                        </Stack>
                                    </Grid>
                                    <Grid item md={7}>
                                        <ImageViewer id={id} />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className='About' sx={{ boxShadow: 0 }}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="About-panel-content"
                                id="About-panel"
                            >
                                <Typography variant='h5'>About the measure</Typography>
                            </AccordionSummary>
                            <Divider />

                            <AccordionDetails>

                                <Typography sx={{ fontWeight: 600 }}>Measure name</Typography>
                                {hasContent(name)}

                                <Typography sx={{ fontWeight: 600 }}>Authors</Typography>
                                {hasContent(authors)}

                                <Typography sx={{ fontWeight: 600 }}>Implementation method</Typography>
                                {hasContent(method)}

                                <Typography sx={{ fontWeight: 600 }}>Implementation duration</Typography>
                                {hasContent(duration)}

                                <Typography sx={{ fontWeight: 600 }}>Measure details</Typography>
                                {hasContent(details)}

                                <Typography sx={{ fontWeight: 600 }}>Acceptance of the measure</Typography>
                                {hasContent(acceptance)}

                                <Typography sx={{ fontWeight: 600 }}>Challenges faced during implementation</Typography>
                                {hasContent(challenges)}

                            </AccordionDetails>
                        </Accordion>

                        <Accordion className='Effects' sx={{ boxShadow: 0 }}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="Effect-panel_content"
                                id="Effect-panel"
                            >
                                <Typography variant='h5'>Effect of the measure</Typography>
                            </AccordionSummary>
                            <Divider />

                            <AccordionDetails>

                                <Typography sx={{ fontWeight: 600 }}>
                                    Method of Impact Assessment
                                </Typography>
                                {EffectElement(methodImpact)}

                                {/* Overall effectiveness */}
                                <Typography sx={{ fontWeight: 600 }}>
                                    Overall effectiveness of the measure
                                </Typography>
                                {EffectElement(effect_overall)}

                                <Typography sx={{ fontWeight: 600 }}>
                                    Details - Effectiveness
                                </Typography>
                                {hasContent(effect_comment)}

                                {/* Capacity */}
                                <Typography sx={{ fontWeight: 600 }}>
                                    Impact on capacity
                                </Typography>
                                {EffectElement(capacity_impact)}

                                <Typography sx={{ fontWeight: 600 }}>
                                    Details - Capacity
                                </Typography>
                                {hasContent(capacity_comment)}

                                {/* Safety */}
                                <Typography sx={{ fontWeight: 600 }}>
                                    Impact on safety
                                </Typography>
                                {EffectElement(safety_impact)}

                                <Typography sx={{ fontWeight: 600 }}>
                                    Details - Safety
                                </Typography>
                                {hasContent(safety_comment)}

                                {/* Environment */}
                                <Typography sx={{ fontWeight: 600 }}>
                                    Impact on environment
                                </Typography>
                                {EffectElement(env_impact)}

                                <Typography sx={{ fontWeight: 600 }}>
                                    Details - environment
                                </Typography>
                                {hasContent(env_comment)}

                                {/* Investment costs */}
                                <Typography sx={{ fontWeight: 600 }}>
                                    Investment costs
                                </Typography>
                                {EffectElement(cost_impact)}

                                <Typography sx={{ fontWeight: 600 }}>
                                    Details - investment costs
                                </Typography>
                                {hasContent(cost_comment)}
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className='Publication' sx={{ boxShadow: 0 }}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="Publication-panel_content"
                                id="Publication-panel"
                            >
                                <Typography variant='h5'>Details of the publication</Typography>
                            </AccordionSummary>
                            <Divider />

                            <AccordionDetails>

                                <Typography sx={{ fontWeight: 600 }}>Publication title    </Typography>
                                {hasContent(title)}

                                <Typography sx={{ fontWeight: 600 }}>Report type          </Typography>
                                {hasContent(report_type)}

                                <Typography sx={{ fontWeight: 600 }}>Publication/Project Reference</Typography>
                                {hasContent(project_link, true)}

                                <Typography sx={{ fontWeight: 600 }}>Other References     </Typography>
                                {hasContent(references)}

                                <Typography sx={{ fontWeight: 600 }}>Other Information/Notes</Typography>
                                {hasContent(otherInformation)}

                            </AccordionDetails>
                        </Accordion>

                    </Paper>
                </Container>
            )
        } // End of 'if' statement

        // This returns before the fetch request is complete
        return <p>Loading...</p>

    }

    catch (error) {
        console.log(error)
    }
    return <Navigate to='/' />
}